const appointmentsStore = {
  state: {
    allAppointments: [],
    unbilledAppointments: [],
  },
  reducers: {
    SET_ALL_APPOINTMENTS: (state, allAppointments) => ({
      ...state,
      allAppointments,
    }),
    SET_UNBILLED_APPOINTMENTS: (state, unbilledAppointments) => ({
      ...state,
      unbilledAppointments,
    }),
  },
  //   effects: (dispatch) => ({
  //     async incrementAsync(payload, state) {
  //       await new Promise((resolve) => setTimeout(resolve, 1000));
  //       dispatch.counter.increment(payload);
  //     },
  //   }),
};

export default appointmentsStore;
